<template>
	<div class="top">
		<div class="music container-fluid">
			<div class="head">
				<div class="Header">悦听音乐</div>
				<div class="search">
					<input placeholder="搜索歌曲名或者作者" class="text" type="text" v-model="query" @keyup.enter="getmusic" />
					<div class="button bi bi-search" @click="getmusic"></div>
				</div>
			</div>
			<div class="Interface">
				<div class="list">
					<ul style="padding: 0">
						<li class="name" v-for="(music, key) in musiclist" :key="key">
							<span class="bi bi-play-circle play" @click="play(key)"></span>
							<span :title="music.name">{{ music.name }}</span>
							<div class="singer">
								歌手：<span v-for="(name, i) in music.artists" :key="i">{{ name.name }}、</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<audio ref="music" class="Music-progress" :src="music" autoplay="autoplay" controls="controls"
				@play="onPlay()" @pause="onPause()"></audio>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		props: ["player"],
		name: "MusicPlayer",
		data() {
			return {
				music: "no",
				query: "",
				musiclist: [],
				control: NaN
			};
		},
		methods: {
			onPause() {
				this.control = false;
			},
			onPlay() {
				this.control = true;
			},
			getmusic() {
				axios
					.get("https://autumnfish.cn/search?keywords=" + this.query)
					.then((music) => {
						this.musiclist = music.data.result.songs;
					});
			},
			play(key) {
				let id = this.musiclist[key].id;
				this.music =
					"https://music.163.com/song/media/outer/url?id=" + id + ".mp3";
				this.player.pause();
				this.player.src = this.music;
			},
		},
		watch: {
			$route(to) {
				this.$nextTick(function() {
					if (to.name === "MusicPlayer") {
						if (!this.player.paused && this.music != "no") {
							this.$refs.music.currentTime = this.player.currentTime;
							this.$refs.music.play();
							this.player.pause();
						}
					}
				})
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this.music != "no") {
				this.player.currentTime = this.$refs.music.currentTime;
				if (this.control) {
					this.player.play();
				}
			}
			next();
		},
	};
</script>

<style scoped>
	.top {
		padding: 80px 44px 0 44px;
	}

	.music {
		width: 800px;
		padding: 20px 30px 10px 30px;
		background: linear-gradient(to bottom,
				rgba(0, 0, 0, 0.6) 0%,
				rgba(0, 0, 0, 0.6) 100%),
			url("../assets/Background/background-5.jpg");
		background-position: right;
		background-repeat: no-repeat;
		background-attachment: scroll;
		background-size: cover;
		border-radius: 10px;
	}

	.head {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.Header {
		min-width: fit-content;
		padding-right: 30px;
		font-size: 20px;
		color: white;
	}

	.search {
		display: flex;
		justify-content: center;
		width: 300px;
	}

	.text {
		width: calc(100% - 36px);
		padding: 5px 0 5px 10px;
		font-size: 14px;
		border: 0;
		border-bottom-left-radius: 10px;
		border-top-left-radius: 10px;
		outline: none;
		border-right: none;
	}

	.button {
		padding: 5px 10px 5px 10px;
		border-left: none;
		cursor: pointer;
		background-color: white;
		border-bottom-right-radius: 10px;
		border-top-right-radius: 10px;
	}

	.Interface {
		display: flex;
		flex-direction: row;
		height: calc(100vh - 285px);
		margin-bottom: 10px;
	}

	.list {
		overflow-y: scroll;
		width: 100%;
	}

	.list::-webkit-scrollbar {
		display: none;
	}

	@media screen and (max-width: 888px) {
		.music {
			width: 100%;
			height: ;
		}

		.top {
			padding: 80px 0 0 0;
		}
	}

	.name {
		list-style-type: none;
		width: 100%;
		line-height: 30px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-bottom: 5px;
		border-bottom: 1px solid white;
		color: white;
	}

	.singer {
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		padding-left: 16px;
	}

	.Music-progress {
		width: 100%;
	}

	.play {
		cursor: pointer;
	}
</style>
